/*
 * Empyra size guide modal.
 *
 * Opens snippets/empyra-size-guide.liquid from the "Size guide" button that
 * snippets/empyra-size-guide-link.liquid renders inside the Size legend.
 *
 * Native <dialog>.showModal() does the hard parts: focus trap, Escape to close,
 * inert background, ::backdrop. There is no focus-management code here because
 * there does not need to be.
 *
 * BACKDROP CLICKS: on a modal <dialog> a click on the backdrop reports the
 * dialog element itself as event.target, because the backdrop is painted by the
 * dialog. That only holds while the dialog has no padding of its own, which is
 * why all spacing lives on .empyra-sizeguide__inner. If you ever put padding
 * back on the dialog, clicking the padding will read as a backdrop click and
 * close it while she is trying to scroll.
 *
 * ANALYTICS: the audit's claim is that sizing is the biggest blocker on the
 * page. This event is how you find out whether that is true here, rather than
 * true in general. Same three sinks and the same best-effort rules as
 * empyra-prepaid.js: feature-detected, wrapped, and never allowed to stop the
 * dialog opening.
 *
 * The init guard matches empyra-prepaid.js. This snippet renders once per page
 * today, but the toggle used to as well until it did not, and that doubled
 * every number it reported.
 */
(function () {
  'use strict';

  if (window.__empyraSizeGuideReady) return;
  window.__empyraSizeGuideReady = true;

  function dialog() {
    return document.getElementById('EmpyraSizeGuide');
  }

  function track() {
    var payload = { location: 'product_page' };
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', 'SizeGuideOpened', payload);
      }
    } catch (e) { /* analytics must never block the dialog */ }
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'size_guide_opened', payload);
      }
    } catch (e) { /* as above */ }
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: 'empyra_size_guide_opened' });
      }
    } catch (e) { /* as above */ }
  }

  function open() {
    var d = dialog();
    if (!d) return;
    if (typeof d.showModal === 'function') {
      d.showModal();
    } else {
      d.setAttribute('open', '');
    }
    track();
  }

  function close() {
    var d = dialog();
    if (!d) return;
    if (typeof d.close === 'function') {
      d.close();
    } else {
      d.removeAttribute('open');
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-empyra-sizeguide-open]')) {
      e.preventDefault();
      open();
      return;
    }

    if (t.closest('[data-empyra-sizeguide-close]')) {
      e.preventDefault();
      close();
      return;
    }

    var d = dialog();
    if (d && d.open && t === d) close();
  });
})();
